var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFictionBooks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Book-Bookmark--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Book Bookmark Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.75a2 2 0 0 0 -2 -2h-0.88a0.52 0.52 0 0 1 -0.44 -0.25 0.48 0.48 0 0 0 -0.43 -0.25h-3a0.5 0.5 0 0 0 -0.5 0.5v7.9a0.25 0.25 0 0 0 0.43 0.17l1.39 -1.39a0.25 0.25 0 0 1 0.36 0l1.39 1.39a0.25 0.25 0 0 0 0.43 -0.17v-5.4a0.5 0.5 0 0 1 0.5 -0.5h0.25a0.5 0.5 0 0 1 0.5 0.5v13a0.5 0.5 0 0 1 -0.5 0.5H15a4.81 4.81 0 0 0 -1.36 0.18 0.52 0.52 0 0 1 -0.44 -0.08 0.51 0.51 0 0 1 -0.2 -0.4V6.25c0 -2.06 1.09 -2.42 1.79 -2.49a0.5 0.5 0 0 0 0.46 -0.5v-1a0.5 0.5 0 0 0 -0.54 -0.5 3.8 3.8 0 0 0 -2.37 0.94 0.51 0.51 0 0 1 -0.68 0A3.81 3.81 0 0 0 9 1.75H2a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h7c1.44 0 2 0.56 2 2a1 1 0 0 0 2 0c0 -1.44 0.56 -2 2 -2h7a2 2 0 0 0 2 -2Zm-15 14H2.5a0.5 0.5 0 0 1 -0.5 -0.5v-13a0.5 0.5 0 0 1 0.5 -0.5H9c1.74 0 2 1.57 2 2.5v11.2a0.51 0.51 0 0 1 -0.2 0.4 0.52 0.52 0 0 1 -0.44 0.08A4.81 4.81 0 0 0 9 17.75Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFictionBooks);
export default ForwardRef;